(function (Drupal, $, once) {
  Drupal.behaviors.pageContentLinksCollapse = {
    attach(context) {

      once('pageContentLinksCollapse', '.custom-menu-wrap', context)
      .forEach(function (wrapper) {

        const $wrapper = $(wrapper);
        const $toggle = $wrapper.find('.collapse_link');
        const collapseId = $toggle.data('collapse-id');
        const $collapse = $('#' + collapseId);

        if (!$toggle.length || !$collapse.length) {
          return;
        }

        /* ----------------------------------
         * click outside → close
         * ---------------------------------- */
        $(document).on('click.pageContentLinksCollapse', function (e) {
          if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
            $collapse.collapse('hide');
          }
        });

        /* ----------------------------------
         * click on link
         * ---------------------------------- */
        $collapse.find('.menu-list').on('click', function () {

          const selectedText = $(this).text().trim();

          // Change toggle text
          $toggle.text(selectedText);

          // Close menu
          $collapse.collapse('hide');
        });

      });
    }
  };
})(Drupal, jQuery, once);
